<template>
    <div id="express-cart">

        <button class="btn shadow-light btn-dark" @click.prevent.stop="handleAdd()" v-if="product.ProductType == 'GiftVoucherProduct'">
            <span>Express Checkout</span>
        </button>

        <div class="link" @click.prevent.stop="handleAdd()" v-else>
            <i class="fal fa-shopping-bag" aria-hidden="true" title="Express Checkout"></i>
        </div>

        <div id="express-popup" v-if="showExpressCart" @click="showExpressCart=false">
            <div class="popup-container shadow-light" @click.stop>
                <div class="head">
                    <p><i class="fal fa-shopping-bag" aria-hidden="true"></i><span>Express checkout</span></p>
                    <button class="btn btn-sqr" @click.stop="showExpressCart=false"><i class="fal fa-times"></i></button>
                </div>
                <hr>
                <div class="product">
                    <div class="image" v-if="product.Image">
                        <img :src="product.Image.URL"/>
                    </div>
                    <div class="quantity vertical-middle">
                        <v-select id="product-quantity"
                                  v-model="selectedQuantity"
                                  :options="quantityOptions"
                                  :clearable="false">
                        </v-select>
                    </div>
                    <div class="name vertical-middle">
                        <div>
                            <p v-if="variation">{{ variation.Title }}</p>
                            <p v-else>{{ product.Title }}</p>
                        </div>
                    </div>
                    <div class="price vertical-middle">
                        <div v-if="correctedPrice() > 0">
                            <p class="sub"
                               :class="{slashed: productAttribute('DiscountedPrice') > 0 && productAttribute('DiscountedPrice') !== correctedPrice()}">
                                ${{ correctedPrice().toFixed(2) }}</p>
                            <p class="sub"
                               v-if="productAttribute('DiscountedPrice') > 0 && productAttribute('DiscountedPrice') !== correctedPrice()">
                                ${{ productAttribute('DiscountedPrice').toFixed(2) }}</p>
                        </div>
                    </div>
                </div>
                <div class="process">
                    <div class="steps">
                        <div id="sent-to" :class="{active: step === 1}">
                            <h4>To</h4>
                            <hr>
                            <label for="name-to">Name</label>
                            <input id="name-to" v-model="orderData.NameTo" type="text" placeholder="">
                            <label for="email-to">Email</label>
                            <input id="email-to" v-model="orderData.EmailTo" type="email" required placeholder="e.g. yourname@domain.com"
                                   :class="{invalid: validation.EmailTo}">
                            <label for="gift-message">Message</label>
                            <textarea id="gift-message" v-model="orderData.GiftMessage" placeholder="add a message"></textarea>
                            <hr>
                        </div>
                        <div id="sent-from" :class="{active: step === 2}">
                            <h4>From</h4>
                            <hr>
                            <label for="name-from">Name</label>
                            <input id="name-from" v-model="orderData.NameFrom" type="text" placeholder="">
                            <label for="email-from">Email</label>
                            <input id="email-from" v-model="orderData.EmailFrom" type="email" required placeholder="e.g. yourname@domain.com"
                                   :class="{invalid: validation.EmailFrom}">
                            <hr>
                        </div>
                        <div id="payment" :class="{active: step === 3}">
                            <h4>Payment options</h4>
                            <hr>
                            <div class="payment-option">
                                <input id="pxpay-option" Name="PaymentMethod" type="radio" value="pxpay" v-model="orderData.PaymentMethod">
                                <label for="pxpay-option" :class="{active: orderData.PaymentMethod === 'pxpay'}">New Credit Card</label>
                                <i class="fad fa-credit-card"></i>
                            </div>
                            <div class="payment-option" v-if="getMember.SavedCard && getMember.SavedCard.ID">
                                <input id="pxpost-option" Name="PaymentMethod" type="radio" value="pxpost" v-model="orderData.PaymentMethod">
                                <label for="pxpost-option" :class="{active: orderData.PaymentMethod === 'pxpost'}">My Card
                                    {{ getMember.SavedCard.CardNumber }}</label>
                                <i class="fab fa-cc-visa"></i>
                            </div>
                            <hr>
                        </div>
                    </div>
                    <div class="mini-nav">
                        <div class="back" v-if="step > 1" @click="step -= 1"><i class="fal fa-long-arrow-left"></i><span>Back a step</span></div>
                        <div v-else></div>
                        <p class="track">{{ step }} / 3</p>
                        <div class="next" v-if="step < 3">
                            <button class="btn btn-dark-small" @click="gotoNext()">Next</button>
                        </div>
                        <button class="btn btn-dark-small" v-else @click="submitOrder">Pay Now</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "ExpressCart",
    data() {
        return {
            showExpressCart: false,
            selectedQuantity: this.quantity > 0 ? this.quantity : 1,
            quantityOptions: Array.from(Array(60).keys(), n => n + 1),
            step: 1,
            orderData: {
                EmailTo: '',
                NameTo: '',
                EmailFrom: '',
                NameFrom: '',
                GiftMessage: '',
                PaymentMethod: 'pxpay'
            },
            validation: {
                EmailTo: false,
                EmailFrom: false
            }
        }
    },
    props: {
        product: {type: Object},
        variation: {type: Object, required: false},
        quantity: {type: Number},
        price: {type: Number, required: false}
    },
    computed: {
        ...mapGetters(['getMember']),
    },
    watch: {
        getMember(val) {
            if (this.orderData.EmailFrom === '') {
                this.orderData.EmailFrom = val.Email;
            }
            if (this.orderData.NameFrom === '') {
                this.orderData.NameFrom = val.FirstName;
            }
        }
    },
    methods: {
        ...mapActions(['expressPayOrder', 'fetchMemberData']),
        handleAdd() {
            this.$emit('trackadd');
            this.showExpressCart = true;
        },
        productAttribute($attr) {
            if (this.variation && this.variation[$attr]) {
                return this.variation[$attr];
            }
            return this.product[$attr];
        },
        correctedPrice(){
          return this.productAttribute('LocalisedPrice') > 0 ? this.productAttribute('LocalisedPrice') : this.price;
        },
        submitOrder() {
            let data = new FormData();
            data.append('EmailTo', this.orderData.EmailTo);
            data.append('NameTo', this.orderData.NameTo);
            data.append('EmailFrom', this.orderData.EmailFrom);
            data.append('NameFrom', this.orderData.NameFrom);
            data.append('GiftMessage', this.orderData.GiftMessage);
            data.append('PaymentMethod', this.orderData.PaymentMethod);
            data.append('ProductID', this.product.ID);
            data.append('VariationID', this.variation ? this.variation.ID : null);
            data.append('Quantity', this.selectedQuantity);
            data.append('UnitPrice', this.price);
            this.expressPayOrder(data);
        },
        gotoNext() {
            this.validation.EmailTo = false;
            this.validation.EmailFrom = false;

            let valid = false;
            if (this.step === 1) {
                if (this.orderData.EmailTo === '' || !this.orderData.EmailTo) {
                    this.validation.EmailTo = true;
                } else {
                    valid = true;
                }
            }

            if (this.step === 2) {
                if (this.orderData.EmailFrom === '' || !this.orderData.EmailFrom) {
                    this.validation.EmailFrom = true;
                } else {
                    valid = true;
                }
            }

            if (valid) {
                this.step += 1;
            }
        }
    },
    mounted() {
        this.fetchMemberData();
    }
}
</script>
